import React, { createContext, useContext, useState, ReactNode } from 'react';

type SeenNotificationContextType = {
  seenStatus: boolean;
  setSeenStatus: React.Dispatch<React.SetStateAction<boolean>>;
};

const SeenNotificationContext = createContext<SeenNotificationContextType | undefined>(undefined);

export const SeenNotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [seenStatus, setSeenStatus] = useState<boolean>(false);

  return (
    <SeenNotificationContext.Provider value={{ seenStatus, setSeenStatus }}>
      {children}
    </SeenNotificationContext.Provider>
  );
};

export const useSeenNotification = (): SeenNotificationContextType => {
  const context = useContext(SeenNotificationContext);
  if (!context) {
    throw new Error('useSeenNotification must be used within a SeenNotificationProvider');
  }
  return context;
};
